export default __webpack_public_path__ + "assets/audios/loop-intro.mp3";